/**
* 头部菜单
*/ 
<template>
  <el-menu class="el-menu-demo" mode="horizontal" background-color="#fff" text-color="#4a5568" active-text-color="#007aff">
    <el-button class="buttonimg">
      <img class="showimg" :src="collapsed?imgsq:imgshow" @click="toggle(collapsed)">
    </el-button>
    <el-submenu index="2" class="submenu">
      <template slot="title">
        <div class="user-info">
          <i class="el-icon-user-solid user-icon"></i>
          <span>超级管理员</span>
        </div>
      </template>
      <el-menu-item @click="exit()" index="2-3">
        <i class="el-icon-switch-button"></i> 退出登录
      </el-menu-item>
    </el-submenu>
  </el-menu>
</template>
<script>
import { loginout } from '../api/userMG'
export default {
  name: 'navcon',
  data() {
    return {
      collapsed: true,
      imgshow: require('../assets/img/show.png'),
      imgsq: require('../assets/img/sq.png'),
      user: {}
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.user = JSON.parse(localStorage.getItem('userdata'))
  },
  methods: {
    // 退出登录
    exit() {
      this.$confirm('确定退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        roundButton: true
      })
        .then(() => {
          setTimeout(() => {
            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '已安全退出'
            })
          }, 500)
        })
        .catch(() => {})
    },
    // 切换显示
    toggle(showtype) {
      this.collapsed = !showtype
      this.$root.Bus.$emit('toggle', this.collapsed)
    }
  }
}
</script>
<style scoped>
.el-menu-demo {
  border-bottom: 1px solid #edf2f7 !important;
  height: 60px;
  display: flex;
  align-items: center;
  padding: 0 20px;
}
.submenu {
  margin-left: auto;
}
/* 隐藏顶部用户菜单的下拉箭头 */
.submenu >>> .el-submenu__icon-arrow {
  display: none !important;
}
.buttonimg {
  height: 40px;
  width: 40px;
  background: var(--tech-gradient); /* 使用渐变色背景 */
  border: none;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: all 0.3s;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(0, 122, 255, 0.2); /* 增加阴影，使其悬浮感更强 */
}
.buttonimg:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 15px rgba(0, 122, 255, 0.3);
  filter: brightness(1.1);
}
.showimg {
  width: 22px;
  height: 22px;
  filter: brightness(0) invert(1); /* 将黑色图标变为纯白色，在蓝色背景下最清晰 */
}
.user-info {
  display: flex;
  align-items: center;
  gap: 8px;
}
.user-icon {
  font-size: 18px;
  color: #718096; /* 加深图标颜色 */
}
</style>


// WEBPACK FOOTER //
// src/components/navcon.vue